import React, { useState } from 'react';
import PropTypes from 'prop-types';

import cx from '@strava/ui/clsx';

import StravaMediaLightbox from 'components/StravaMediaLightbox';

import styles from './MediaThumbnailList.scss';

function MediaThumbnailList({
  isLoggedIn,
  items,
  viewableCount,
  thumbnailSize
}) {
  const [lightboxState, setLightboxState] = useState({
    isOpen: false,
    selectedIndex: 0
  });

  const itemsToDisplay = viewableCount - 1;
  const hasMoreItems = items.length - viewableCount > 0;
  const moreCount = items.length - itemsToDisplay;
  const adjustedItems = hasMoreItems ? items.slice(0, itemsToDisplay) : items;

  function handleItemClick(index) {
    setLightboxState({ isOpen: true, selectedIndex: index });
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <>
      <MediaList>
        {adjustedItems.map((item, index) => (
          <MediaListItem
            key={item.photo_id}
            style={{ height: thumbnailSize, width: thumbnailSize }}
          >
            {isLoggedIn ? (
              <MediaListItemButton
                onClick={() => handleItemClick(index)}
                onKeyPress={() => handleItemClick(index)}
              >
                <img src={item.thumbnail} alt="" />
              </MediaListItemButton>
            ) : (
              <div className={styles.buttonLoggedOut}>
                <img src={item.thumbnail} alt="" />
              </div>
            )}
          </MediaListItem>
        ))}
        {hasMoreItems ? (
          <MediaListItem
            style={{ height: thumbnailSize, width: thumbnailSize }}
          >
            {isLoggedIn ? (
              <MediaListItemButton
                className={styles.seeMoreButton}
                onClick={() => handleItemClick(0)}
                onKeyPress={() => handleItemClick(0)}
              >
                +{moreCount}
              </MediaListItemButton>
            ) : (
              <div
                className={cx(
                  styles.buttonLoggedOut,
                  styles.seeMoreButtonLoggedOut
                )}
              >
                +{moreCount}
              </div>
            )}
          </MediaListItem>
        ) : null}
      </MediaList>

      {lightboxState.isOpen ? (
        <StravaMediaLightbox
          selectedPhotoIndex={lightboxState.selectedIndex}
          photoList={items}
          onCloseRequest={() => {
            setLightboxState({ isOpen: false });
          }}
        />
      ) : null}
    </>
  );
}

MediaThumbnailList.defaultProps = {
  isLoggedIn: false,
  items: [],
  viewableCount: 8,
  thumbnailSize: 60
};

MediaThumbnailList.propTypes = {
  isLoggedIn: PropTypes.bool,
  items: PropTypes.arrayOf(
    // TODO: Look into if we have have this shared somehow
    PropTypes.shape({
      media_type: PropTypes.number.isRequired,
      photo_id: PropTypes.string.isRequired,
      large: PropTypes.string.isRequired,
      thumbnail: PropTypes.string.isRequired,
      caption_escaped: PropTypes.string,
      viewing_athlete_id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
      ]),
      owner_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      editable: PropTypes.bool
    })
  ),
  viewableCount: PropTypes.number,
  thumbnailSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

/**
 * MediaList
 */
function MediaList({ className, ...props }) {
  return <ul {...props} className={cx(styles.list, className)} />;
}

MediaList.defaultProps = {
  className: undefined
};

MediaList.propTypes = {
  className: PropTypes.string
};

/**
 * MediaListItem
 */

function MediaListItem({ className, ...props }) {
  return <li {...props} className={cx(styles.item, className)} />;
}

MediaListItem.defaultProps = {
  className: undefined
};

MediaListItem.propTypes = {
  className: PropTypes.string
};

/**
 * MediaListItemButton
 */

function MediaListItemButton({ className, ...props }) {
  return (
    <div
      {...props}
      role="button"
      className={cx(styles.button, className)}
      tabIndex="0"
    />
  );
}

MediaListItemButton.defaultProps = {
  className: undefined
};

MediaListItemButton.propTypes = {
  className: PropTypes.string
};

export default MediaThumbnailList;
